"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var latest_service_1 = require('./service/latest.service');
var Issue = (function () {
    function Issue() {
    }
    return Issue;
}());
var LatestComponent = (function () {
    function LatestComponent(latestService) {
        this.latestService = latestService;
        this.hasDumped = false;
        this.latestIssue = [];
    }
    LatestComponent.prototype.ngOnInit = function () {
        this.getIssue();
    };
    LatestComponent.prototype.ngDoCheck = function () {
        if (this.response && !this.hasDumped) {
            this.latestIssue = this.unpackData(this.response);
            console.log(this.latestIssue);
            this.hasDumped = true;
        }
    };
    LatestComponent.prototype.getIssue = function () {
        var _this = this;
        this.latestService.getLatestIssue()
            .subscribe(function (response) { return _this.response = response; }, function (error) { return _this.errorMessage = error; });
    };
    LatestComponent.prototype.unpackData = function (data) {
        var info = data.items;
        var resArray = [];
        for (var i = 0; i < info.length; i++) {
            var box = info[i];
            var obj = new Issue();
            obj.title = box.title;
            obj.body = box.body;
            obj.html_url = box.html_url;
            obj.comments = box.comments;
            obj.created_at = box.created_at;
            obj.state = box.state;
            resArray.push(obj);
        }
        return resArray;
    };
    LatestComponent = __decorate([
        core_1.Component({
            selector: 'latest-weekly',
            template: require('./templates/latest.component.html'),
            providers: [latest_service_1.LatestService]
        }), 
        __metadata('design:paramtypes', [latest_service_1.LatestService])
    ], LatestComponent);
    return LatestComponent;
}());
exports.LatestComponent = LatestComponent;
//# sourceMappingURL=latest.component.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/home/latest.component.js
 ** module id = 347
 ** module chunks = 0
 **/